/**
 * Query String for findPeople service which calls the findPeople API. Value null fetches all contacts from the specified folder
 */
export const FETCH_CONTACTS_INITIAL_QUERY: string = null;

/**
 * Offset value for findPeople service which calls the findPeople API. Value 0 returns contacts from index 0
 */
export const FETCH_CONTACTS_INITIAL_OFFSET: number = 0;

/**
 * Used by the findPeople service to specify the maximum number of entries returned by the findPeople API in the first call.
 */
export const FETCH_CONTACTS_INITIAL_MAX_RESULTS: number = 50;

/**
 * Used by the findPeople service call to specify which folder to get contacts from. usercuratedcontacts is the universal folder
 * name which contains all saved contacts for a user.
 */
export const UNIVERSAL_FOLDER_NAME_FOR_USER_CONTACTS: string = 'usercuratedcontacts';

/**
 * Used by isSupportedPersona to check whether a contact was added through WindowsLive. If so, we filter out the contact and don't show in
 * the PeopleHub
 */
export const WINDOWS_LIVE_FOLDER_NAME: string = 'WindowsLive Contacts';

/**
 * Used as the initial value for scroll index for a folder in PeopleListWrapper
 */
export const SCROLL_INDEX_INITIAL_VALUE: number = 50;

/**
 * Used for controlling the list scrolling for a folder by PeopleListWrapper
 */
export const SCROLL_INDEX_INCREMENT_VALUE: number = 20;

/**
 * Used by fetchAllFolderContactsActionCreator to use as maxEntriesReturned. This is there because we don't want to make many network calls for
 * a folder. In almost all cases, a folder won't have more than 500 contacts
 */
export const MAX_CONTACTS_TO_FETCH_FOR_FOLDER: number = 500;

/**
 * Used for checking if the passed folder id is contacts
 */
export const DEFAULT_CONTACTS_FOLDER_ID = 'contacts';
